
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/machine-sales",
      function () {
        return require("private-next-pages/machine-sales/index.page.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/machine-sales"])
      });
    }
  